export default __webpack_public_path__ + "static/media/CalciumIncrease.d03ffcbe.jpg";